import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tip.png'


const _withScopeId = n => (_pushScopeId("data-v-df0d6b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone-warp-tip hea-row hea-justifyCL" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "温馨提示: 可下载、查看两个月内的体检报告")
], -1))
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "form-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "体检人 :", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "体检时间 :", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "报告时间 :", -1))
const _hoisted_8 = { class: "btn-content hea-justifyCR" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("下载报告")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("查看报告")
const _hoisted_11 = {
  key: 1,
  class: "hea-column not-data hea-justifyC"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/notData.png",
  alt: "",
  class: "not-data-img"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "not-data-title hea-justifyC",
  style: {"width":"100%"}
}, "暂无报告", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "pdf-download" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "复制此链接粘贴到浏览器打开即可查看下载", -1))
const _hoisted_17 = { class: "download-url van-multi-ellipsis--l2" }
const _hoisted_18 = { class: "operation" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("复制")

import { reactive, ref, onMounted } from 'vue';
    import { Toast } from 'vant';
    import tabbar from "src/components/common/tabbar";
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { MemberService, PhysicalService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter } from 'vue-router';
    import UpageList from 'src/components/common/page-list';
    import PageBack from 'src/components/common/page-back';
    import pdfPreview from 'src/components/common/pdf-preview';
    import API from "@/apis/urls";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { setAccessToken, setRefreshToken } = useToken();
    const router = useRouter();
    let dataList = ref([])

    // 是否显示报告
    let showReport = ref<boolean>(false);
    // 显示下载地址
    let downloadUrl = ref<string>("");
    // 是否显示报告下载地址
    let showPDFDownloadModel = ref<boolean>(false);

    /**
     * 数据列表 
     */
    let getReportList = async ()=>
    {
        try {
            let { content: res } = await PhysicalService.instance.getReportList();
            dataList.value = res.data || [];
        } catch (err) {
            Toast(err);
        }
    }

    let copyPdfUrl = (str) =>
    {
        let save = function (e) {
            e.clipboardData.setData("text/plain", str);
            e.preventDefault();
        };
        let input = document.createElement("input");
        input.value = str;
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length), document.execCommand("Copy");
        document.body.removeChild(input);
        Toast({
            message: "复制成功",
            duration: 1000
        });
        showPDFDownloadModel.value = false;
    }

    // 下载报告
    const onDownReport = async (id: any) => 
    {
        showPDFDownloadModel.value = true;

        // 获取
        let token = JSON.parse(localStorage.getItem("token")).accessToken;
        let data = {
            timestamp: Math.floor(dayjs().valueOf() / 1000),
            id: id
        }

        let url = `${API.downloadReportUrl}?token=${token}&data=${encodeURIComponent(JSEncryptUtils.decrypt(JSON.stringify(data)))}`;
        downloadUrl.value = url; 
    }

    // 查看报告
    const onSelectReport = (item) =>
    {
        router.push({name: "reportDetail", query:{id: item.physicalTaskId}});
    }
    onMounted(()=>
    {
        getReportList();
    })  

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageBack)),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(dataList).length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(dataList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "panel-body",
              key: index
            }, [
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", null, [
                  _hoisted_5,
                  _createElementVNode("div", null, _toDisplayString(item.memberName), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_6,
                  _createElementVNode("div", null, _toDisplayString(item.physicalDate), 1)
                ]),
                _createElementVNode("li", null, [
                  _hoisted_7,
                  _createElementVNode("div", null, _toDisplayString(item.reportTime), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_button, {
                  plain: "",
                  hairline: "",
                  type: "primary",
                  round: "",
                  color: "#D41446",
                  class: "btn",
                  onClick: ($event: any) => (onDownReport(item.physicalTaskId))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_van_button, {
                  round: "",
                  type: "primary",
                  color: "linear-gradient(to right, #F8628A, #E23A67)",
                  class: "btn",
                  onClick: ($event: any) => (onSelectReport(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
    ]),
    _createVNode(_component_van_dialog, {
      show: _unref(showPDFDownloadModel),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showPDFDownloadModel) ? (showPDFDownloadModel).value = $event : showPDFDownloadModel = $event)),
      showConfirmButton: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(downloadUrl)), 1),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_van_button, {
              plain: "",
              hairline: "",
              type: "primary",
              round: "",
              color: "#D41446",
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showPDFDownloadModel) //@ts-ignore
 ? showPDFDownloadModel.value = false : showPDFDownloadModel= false))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_van_button, {
              round: "",
              type: "primary",
              color: "linear-gradient(to right, #F8628A, #E23A67)",
              class: "btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyPdfUrl)(_unref(downloadUrl))))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})